export default {
	"当前存在正在编辑的题目无法创建新题目": "當前存在正在編輯的題目，無法創建新的題目",
	"请添加页后再添加题目": '請添加頁后再添加題目',
	"此链接可分享到外部进行测试项目结束后链接自动失效": '此連結可分享到外部進行測試，專案結束後連結自動失效',
	"此测试仅针对系统内登录后测试分享如无系统账号无法打开慎用": '此測試僅針對系統內登陸後測試，分享如無系統帳號無法打開，慎用',
	"确定提交": '確定提交',
	'删除成功': '刪除成功',
	'确定要删除文件': '確定要刪除檔',
	"答案必须为数字": '答案必須為數位',
	"答案不在范围内": '答案不在範圍内',
	"最多上传": '最多上傳',
	"个附件": '個附件',
	"最少上传": "最少上傳",
	"存在未参与排序的选项": '存在未參與排序的選項',
	"最少排": '最少排',
	"最多只能排": '最多只能排',
	"项": '項',
	"问题半开放未填": '問題半開放未填',
	"矩阵半开放未填": '矩陣半開放未填',
	"选项半开放未填": '選項半開放未填',
	"成功": '成功',
	"清除成功": '清除成功',
	"上传成功": '上傳成功',
	"提交成功": '提交成功',
	"您有题目未作答请作答后提交": '您有題目未作答,請作答后提交',
	"该题已作答": '該題已作答',
	"最多选择": '最多選擇',
	"只能上传图片": '只能上傳圖片',
	"只能上传视频": '只能上傳視頻',
	"只能上传图片或视频": '只能上傳圖片或視頻',
	"上传失败": '上傳失敗',
	"请输入": '請輸入',
	"请输入手机号": '請輸入手機號',
	"手机号有误": '手機號有誤',
	"手机号不能为空": '手機號不能爲空',
	"同一个设备只能填一次": '同一個設備只能填一次',
	"请设置题号": '請設置題號',
	"请选择题型": '請選擇題型',
	"选择题型": '選擇題型',
	"必填": '必填',
	"配额题": '配額題',
	"题目": '題目',
	"问题描述": '問題描述',
	"请在这里输入": '請在這裏輸入',
	"请填写题号": '請填寫題號',
	'题号': '題號',
	"请填写题目": '請填寫題目',
	"必填项未填": '必填項未填',
	"超出上传文件限制的个数": '超出上傳文件限制的個數',
	"上传图片只能是jpg或者png格式": '上傳圖片只能是jpg或者png格式',
	"确定移除": '確定移除',
	"存在重复的值请修改后提交": '存在重複的值，請修改后提交',
	"请选择": '請選擇',
	"不能为空": '不能爲空',
	"请输入随机的选项若勾选全部随机则不需要填写": '請輸入隨機的選項，若勾選全部隨機則不需要填寫',
	"请输入不随机的选项": '請輸入不隨機的選項',
	"请输入行问题的选项若勾选全部随机则不需要填写": '請輸入行問題的選項，若勾選全部隨機則不需要填寫',
	"请输入随机的问题若勾选全部随机则不需要填写": '請輸入隨機的問題，若勾選全部隨機則不需要填寫',
	"表示问题随机": '表示值为1,2,3的问题随机，用英文逗号隔开',
	"请输入列随机": '請輸入列隨機的問題，若勾選全部隨機則不需要填寫',
	"答题时限有误": '答題時限有誤',
	"请选择量表类型": '請選擇量表類型',
	"请输入类型名称": '請輸入類型名稱',
	"请输入选项数量": '請輸入選項數量',
	"选项数量必须是数字": '選項數量必須是數字',
	"默认样式最大数量": '默認樣式最大數量為10',
	"最大上传数不能小于最小上传数":'最大上傳數不能小於最小上傳數',
	"值不能为空":'值不能爲空',
	"值必须为数字":'值必須爲數字',
	"选项不能为空":'選項不能爲空',
	"问题不能为空":'問題不能爲空',
	"问卷已发布修改可能造成问卷出错请谨慎操作":'問卷已發佈，修改可能造成問卷出錯請謹慎操作。若確需修改，修改後勿忘點擊保存按鈕',
	"复制题目错误请重新复制":'複製題目錯誤，請重新複製',
	"复制成功":'複製成功，可在新建一題処粘貼',
	"确认要删除此题":'確定要刪除此題？',
	"分类名称不能为空":'分類名稱不能爲空',
	"添加成功":'添加成功',
	"请填写划线内容":'請填寫劃綫内容',
	"划线内容未填":'劃綫内容未填',
	"请选择量表类型":'請選擇量表類型',
	"确定删除此页":'確定刪除此頁？',
	"这是最后一页了":'這是最後一頁了',
	"该项目已发布如再使用导入可能产生无法挽回的后果":'該項目已發佈，如再使用導入可能產生無法挽回的後果，請謹慎使用！確實要導入請點擊‘是’，取消請點‘否’。',
	"是否复制分享链接":'是否複製分享鏈接',
	"超出文件上传数量":'超出文件上傳數量',
	"产品至少有一页数据":'產品至少有一頁數據',
  "请签名后保存":'請簽名後保存',
  "联动选项":'聯動選項',
  "请上传csv格式文件":'請上傳csv格式檔案',
  "联动选项未填":'聯動選項未填',
  "请勾选":'請勾選',
  "标注图片未传":'標注圖片未傳',
  "示例":'示例'
}	